import Meter, { getChangePercent } from "@/components/Meter";
import { DateHelper } from "@/lib/dates";
import { useTheme } from "@emotion/react";
import { formatCurrency } from "@ternary/api-lib/analytics/utils/NumberFormatUtils";
import Box from "@ternary/web-ui-lib/components/Box";
import Flex from "@ternary/web-ui-lib/components/Flex";
import { getDate, getDaysInMonth } from "date-fns";
import React from "react";
import copyText from "../../copyText";

interface Props {
  isLoading: boolean;
  lastMonthSpend: number;
  lastMTDSpend: number;
  thisMTDSpend: number;
}

export default function AzureStorageBBMeters(props: Props): React.JSX.Element {
  const theme = useTheme();
  const now = new DateHelper();

  const mtdSpendComparison = getChangePercent({
    biggerIsBetter: false,
    value: props.thisMTDSpend,
    comparison: props.lastMTDSpend,
    theme,
  });

  const avgDailySpend = props.thisMTDSpend / getDate(now.date);
  const forecastedSpend = avgDailySpend * getDaysInMonth(now.date);

  const forecastedSpendComparison = getChangePercent({
    biggerIsBetter: false,
    comparison: props.lastMonthSpend,
    value: forecastedSpend,
    theme,
  });

  return (
    <Flex>
      <Meter
        header={copyText.awsComputeMeterLastMonthTotalCostLabel}
        loading={props.isLoading}
        value={formatCurrency({ number: props.lastMonthSpend })}
        width="33%"
      />
      <Box
        borderRight={`1px solid ${theme.border_color}`}
        marginHorizontal={theme.space_lg}
      />
      <Meter
        footerColor={mtdSpendComparison.color}
        footerIcon={mtdSpendComparison.icon}
        footerTitle={copyText.awsComputeMeterMTDSpendComparisonCaption}
        footerValue={mtdSpendComparison.textValue}
        header={copyText.awsComputeMeterCurrentMonthTotalCostLabel}
        loading={props.isLoading}
        value={formatCurrency({ number: props.thisMTDSpend })}
        width="33%"
      />
      <Box
        borderRight={`1px solid ${theme.border_color}`}
        marginHorizontal={theme.space_lg}
      />
      <Meter
        footerColor={forecastedSpendComparison.color}
        footerIcon={forecastedSpendComparison.icon}
        footerTitle={copyText.awsComputeMeterForecastedSpendComparisonCaption}
        footerValue={forecastedSpendComparison.textValue}
        header={copyText.awsComputeMeterForecastedSpendLabel}
        loading={props.isLoading}
        value={formatCurrency({ number: forecastedSpend })}
        width="33%"
      />
    </Flex>
  );
}
